import React, {useEffect, useState} from 'react'
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import {Stomp} from "@stomp/stompjs";
import SockJS from "sockjs-client";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import DHSelectionComponent from "../../../general/DHSeclectionCompontent";
import BoardAufrufRow from "./BoardAufrufRow";
import ConfirmDialog from "../../../general/ConfirmDialog";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import DateUtil from "../../../../util/DateUtil";
import {InputNumber} from "primereact/inputnumber";
import {getFromLocalStorageWithDefault, saveToLocalStorage} from "../../../../util/localStorageZugriff";

let stompClient = undefined;

// wie in der BoardAufrufArea: nach dieser Zeit ohne Ergebnis wird ein Aufruf rot markiert
const MINUTES_TO_ERROR = 20;

// nach so vielen Minuten seit dem Aufrufzeitpunkt wird ein Spiel, bei dem noch nicht alle da sind, als überfällig markiert
const KEY_MINUTEN_UEBERFAELLIG = "dh_anwesenheit_minuten_ueberfaellig";
const DEFAULT_MINUTEN_UEBERFAELLIG = 10;

export default function AnwesenheitArea({eventOperatorId}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [selectedBoardGameId, setSelectedBoardGameId] = useState(undefined);
    const [showAufrufDialog, setShowAufrufDialog] = useState(false);

    const [tournaments, setTournaments] = useState([]);
    const [selectedTournament, setSelectedTournament] = useState(undefined);

    const [boardsMitGame, setBoardsMitGame] = useState([]);

    const [minutenUeberfaellig, setMinutenUeberfaellig] = useState(() => getFromLocalStorageWithDefault(KEY_MINUTEN_UEBERFAELLIG, DEFAULT_MINUTEN_UEBERFAELLIG));
    // regelmäßig neu rendern, damit Spiele auch ohne neue Websocket-Nachricht überfällig werden
    const [jetzt, setJetzt] = useState(new Date());

    useEffect(() => {
        const intervalId = setInterval(() => setJetzt(new Date()), 15000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if( eventOperatorId === null || eventOperatorId === undefined) {
            return;
        }
        ladeTournaments();

    }, [eventOperatorId]);

    useEffect(() => {
        stompClient = Stomp.over(function () {
            return new SockJS(ConfigUtil.getConfig().websocketUrl);
        });
        stompClient.reconnect_delay = 10000;
        // stompClient.debug = function (str) {}; // Disable debug logging
        stompClient.connect({},
            (x) => {
                console.log("Websocket - connect success");
                // Spiele, Aufrufe und Anwesenheit kommen, wie in der BoardAufrufArea, über die Boardinfos
                const destinationBoardInfos = "/topic/public/eventoperator/board/infos/" + eventOperatorId;
                console.log("subscribe to " + destinationBoardInfos);
                stompClient.subscribe(destinationBoardInfos, (payload) => {
                    const body = JSON.parse(payload.body);
                    setBoardsMitGame(body.boardsMitGame);
                    console.log(body.boardsMitGame);
                });
            },
            (x) => {
                console.log("Websocket - connect error:");
            },
            (x) => {
                console.log("Websocket - disconnect:");
            });

        return () => {
            if( stompClient !== null && stompClient !== undefined) {
                console.log("Websocket - disconnect:");
                stompClient.disconnect(() => {});
            }
        };
    }, []);

    const ladeTournaments = () => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.tournament + "/tournaments/started/"+ eventOperatorId,
            json => {
                const tournamentsMitAnwesenheitspruefung = json.filter(t => t.anwesenheitspruefungScorer);
                setTournaments(tournamentsMitAnwesenheitspruefung);
                if( tournamentsMitAnwesenheitspruefung.length === 1) {
                    setSelectedTournament(tournamentsMitAnwesenheitspruefung[0]);
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Turniere: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Turniere: " + error.message);
            }
        );
    }

    const boardAufrufen = () => {
        setErrorMessage(undefined)
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.eventoperator + "/boardaufrufen/" + selectedBoardGameId,
            {},
            json => {
                setInfoMessage("Game wurde als aufgerufen markiert.");
                setShowAufrufDialog(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowAufrufDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setShowAufrufDialog(false);
            }
        );
    }

    const getTournamentSelection = () => {
        const tmp = [];
        tmp.push({name: 'Auswahl löschen', code: undefined});
        for (const t of tournaments) {
            tmp.push({name: t.bezeichnung, code: t.id});
        }
        return <div>
            <span style={{marginRight: 10}}>Eventauswahl:</span>
            <DHSelectionComponent title="Auswahl" disabled={false} value={selectedTournament ? selectedTournament.id : undefined} values={tmp}
                                  onChange={(id) => {
                                      if( id === undefined) {
                                          setSelectedTournament(undefined);
                                      } else {
                                          let tournament = tournaments.filter(t => t.id === id)[0];
                                          setSelectedTournament(tournament);
                                      }
                                  }}/>
        </div>
    }

    // nur Spiele aus Events mit Anwesenheitsprüfung, die Eventliste ist bereits danach gefiltert
    const getGamesMitAnwesenheitspruefung = () => {
        if (boardsMitGame === null || boardsMitGame === undefined) {
            return [];
        }
        const tournamentIds = selectedTournament !== undefined ? getTournamentIds(selectedTournament) : tournaments.flatMap(t => getTournamentIds(t));
        return boardsMitGame.filter(boardGame => tournamentIds.includes(boardGame.tournamentId));
    }

    // die Spiele der KO-Phase laufen unter eigenen Gold-, Silber- bzw. Bronze-Turnieren
    const getTournamentIds = (tournament) => {
        return [tournament.id, tournament.goldTurnierId, tournament.silberTurnierId, tournament.bronzeTurnierId]
            .filter(id => id !== null && id !== undefined);
    }

    // beim Schreiber zählt nur, dass einer da ist. Ist keiner zum Spiel eingetragen, wird auch keiner erwartet.
    const isSchreiberErwartet = (game) => {
        return !!game.schreiberId || !!game.schreiberName || game.schreiberAnwesend === true;
    }

    const isAlleAnwesend = (game) => {
        return game.player1Anwesend === true && game.player2Anwesend === true
            && (!isSchreiberErwartet(game) || game.schreiberAnwesend === true);
    }

    // das BoardGame enthält keine Spielernamen, nur die Beschreibung "Spieler 1 vs. Spieler 2"
    const getSpielerName = (game, index) => {
        if (!game.gameDescription) {
            return "";
        }
        const namen = game.gameDescription.split(" vs. ");
        if (namen.length !== 2) {
            return index === 0 ? game.gameDescription : "";
        }
        return namen[index];
    }

    const getAnwesenheitRow = (label, name, anwesend) => {
        return <div style={{display: "flex", alignItems: "center", marginBottom: 5}}>
            {anwesend ?
                <i className="pi pi-check-circle" style={{color: "green", fontSize: 20, marginRight: 10}}/> :
                <i className="pi pi-clock" style={{color: "orange", fontSize: 20, marginRight: 10}}/>
            }
            <span style={{width: 90, color: "gray"}}>{label}</span>
            <span style={{flex: 1, fontWeight: anwesend ? "normal" : "bold"}}>{name}</span>
            <span style={{color: anwesend ? "green" : "orange"}}>{anwesend ? "anwesend" : "fehlt noch"}</span>
        </div>
    }

    const getAufrufe = (game) => {
        if (!game.aufgerufenZeitpunkt1) {
            return "";
        }
        return <div style={{marginTop: 5, fontSize: 14}}>
            <BoardAufrufRow label="Aufruf 1" timestamp={game.aufgerufenZeitpunkt1} minutesToError={MINUTES_TO_ERROR}/>
            <BoardAufrufRow label="Aufruf 2" timestamp={game.aufgerufenZeitpunkt2} minutesToError={MINUTES_TO_ERROR}/>
            <BoardAufrufRow label="Aufruf 3" timestamp={game.aufgerufenZeitpunkt3} minutesToError={MINUTES_TO_ERROR}/>
        </div>
    }

    const getMinutenSeitAufruf = (game) => {
        return Math.floor((jetzt.getTime() - new Date(game.aufrufzeitpunkt).getTime()) / 60000);
    }

    const isUeberfaellig = (game) => {
        return !isAlleAnwesend(game) && hatAufrufzeitpunkt(game)
            && jetzt.getTime() - new Date(game.aufrufzeitpunkt).getTime() > minutenUeberfaellig * 60000;
    }

    const getRahmenFarbe = (game, alleAnwesend, ueberfaellig) => {
        if (alleAnwesend) {
            return "green";
        }
        return ueberfaellig ? "red" : "orange";
    }

    const getGameCard = (game) => {
        const alleAnwesend = isAlleAnwesend(game);
        const ueberfaellig = isUeberfaellig(game);
        return <div key={"key_anwesenheit_" + game.id}
                    style={{border: ueberfaellig ? "2px solid red" : "1px solid #ddd", borderLeft: "6px solid " + getRahmenFarbe(game, alleAnwesend, ueberfaellig), borderRadius: 5,
                        backgroundColor: ueberfaellig ? "rgba(255, 0, 0, 0.08)" : undefined,
                        padding: 10, marginBottom: 10, fontSize: 16, width: 450, maxWidth: "100%"}}>
            {ueberfaellig &&
                <div style={{display: "flex", alignItems: "center", backgroundColor: "red", color: "white", fontWeight: "bold",
                    borderRadius: 3, padding: "4px 8px", marginBottom: 8}}>
                    <i className="pi pi-exclamation-triangle" style={{marginRight: 8}}/>
                    Seit {getMinutenSeitAufruf(game)} Min. aufgerufen, es fehlt noch jemand
                </div>
            }
            <div style={{display: "flex", alignItems: "center", marginBottom: 5}}>
                <span style={{flex: 1, fontWeight: "bold"}}>Board: {game.boardBezeichnung}</span>
                {!alleAnwesend && (game.aufgerufenZeitpunkt3 ?
                    // nach dem dritten Aufruf ist kein weiterer möglich
                    <VolumeUpIcon style={{fontSize: 30, color: "lightgray", cursor: "not-allowed"}} titleAccess="Es wurde bereits dreimal aufgerufen"/> :
                    <VolumeUpIcon style={{fontSize: 30, cursor: "pointer"}} onClick={() => {
                        setSelectedBoardGameId(game.id);
                        setShowAufrufDialog(true);
                    }}/>
                )}
            </div>
            {game.aufgerufen && <div style={{color: "green", fontSize: 14, marginBottom: 5}}>Bereits aufgerufen</div>}
            {selectedTournament === undefined &&
                <div style={{fontSize: 12, color: "gray", marginBottom: 5}}>Event: {game.tournamentBezeichnung}</div>
            }
            {hatAufrufzeitpunkt(game) &&
                <div style={{fontSize: 14, marginBottom: 5}}>Aufrufzeitpunkt: {DateUtil.localDateTimeToString(game.aufrufzeitpunkt)}</div>
            }
            {getAnwesenheitRow("Spieler 1", getSpielerName(game, 0), game.player1Anwesend === true)}
            {getAnwesenheitRow("Spieler 2", getSpielerName(game, 1), game.player2Anwesend === true)}
            {isSchreiberErwartet(game) && getAnwesenheitRow("Schreiber", game.schreiberName ? game.schreiberName : "-", game.schreiberAnwesend === true)}
            {!alleAnwesend && getAufrufe(game)}
        </div>
    }

    // den Aufrufzeitpunkt setzt das Backend erst, wenn der Scorer das Spiel abholt
    const hatAufrufzeitpunkt = (game) => {
        return game.aufrufzeitpunkt !== null && game.aufrufzeitpunkt !== undefined;
    }

    const getGameCards = (gameListe, textWennLeer) => {
        if (gameListe.length === 0) {
            return <div style={{marginTop: 10, marginBottom: 20}}>{textWennLeer}</div>
        }
        return <div style={{display: "flex", flexWrap: "wrap", columnGap: 10}}>
            {gameListe.map(game => getGameCard(game))}
        </div>
    }

    // bei vielen Boards spart die Tabelle Platz, hier muss niemand mehr gesucht werden
    const getGameTabelle = (gameListe) => {
        if (gameListe.length === 0) {
            return <div style={{marginTop: 10, marginBottom: 20}}>Keine Spiele vorhanden.</div>
        }
        const zellenStyle = {padding: "5px 10px", borderBottom: "1px solid #ddd", textAlign: "left"};
        return <div style={{overflowX: "auto"}}>
            <table style={{borderCollapse: "collapse", fontSize: 16}}>
                <thead>
                <tr>
                    <th style={zellenStyle}>Board</th>
                    {selectedTournament === undefined && <th style={zellenStyle}>Event</th>}
                    <th style={zellenStyle}>Spieler 1</th>
                    <th style={zellenStyle}>Spieler 2</th>
                    <th style={zellenStyle}>Schreiber</th>
                    <th style={zellenStyle}>Aufrufzeitpunkt</th>
                </tr>
                </thead>
                <tbody>
                {gameListe.map(game => <tr key={"key_anwesend_" + game.id}>
                    <td style={zellenStyle}>{game.boardBezeichnung}</td>
                    {selectedTournament === undefined && <td style={zellenStyle}>{game.tournamentBezeichnung}</td>}
                    <td style={zellenStyle}>{getSpielerName(game, 0)}</td>
                    <td style={zellenStyle}>{getSpielerName(game, 1)}</td>
                    <td style={zellenStyle}>{isSchreiberErwartet(game) ? (game.schreiberName ? game.schreiberName : "anwesend") : "-"}</td>
                    <td style={zellenStyle}>{hatAufrufzeitpunkt(game) ? DateUtil.localDateTimeToString(game.aufrufzeitpunkt) : "-"}</td>
                </tr>)}
                </tbody>
            </table>
        </div>
    }

    const headerRow = (text) => {
        return <div style={{backgroundColor: "gray", fontSize: 20, marginTop: 20, marginBottom: 10, padding: 10, color: "white"}}>{text}</div>
    }

    const gamesMitAnwesenheitspruefung = getGamesMitAnwesenheitspruefung();
    const gamesWartend = gamesMitAnwesenheitspruefung.filter(game => !isAlleAnwesend(game));
    const gamesAlleAnwesend = gamesMitAnwesenheitspruefung.filter(game => isAlleAnwesend(game));
    const gamesUeberfaellig = gamesWartend.filter(game => isUeberfaellig(game)).length;

    return <div style={{padding: 20}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div style={{marginBottom: 10}}>Hier kannst du für Events, welche die Anwesenheitsprüfung aktiviert haben, die Anwesenheiten überprüfen.</div>
        <div style={{marginBottom: 10}}>Es werden nur gestartete Events angezeigt bei denen die Anwesenheitsprüfung aktiv ist.</div>
        {getTournamentSelection()}
        <div style={{display: "flex", alignItems: "center", flexWrap: "wrap", gap: 10, marginTop: 10}}>
            <span>Spiel rot markieren, wenn nach dem Aufrufzeitpunkt mehr als</span>
            <InputNumber value={minutenUeberfaellig} min={1} max={120} showButtons size={3}
                         onValueChange={(e) => {
                             // beim Leeren des Feldes den bisherigen Wert behalten
                             if (e.value === null || e.value === undefined) {
                                 return;
                             }
                             setMinutenUeberfaellig(e.value);
                             saveToLocalStorage(KEY_MINUTEN_UEBERFAELLIG, e.value);
                         }}/>
            <span>Minuten vergangen sind und noch nicht alle anwesend sind.</span>
        </div>
        {headerRow("Warten auf Anwesenheit (" + gamesWartend.length + ")"
            + (gamesUeberfaellig > 0 ? " - davon " + gamesUeberfaellig + " überfällig" : ""))}
        {getGameCards(gamesWartend, "Aktuell wird bei keinem Spiel auf Spieler oder Schreiber gewartet.")}
        {headerRow("Alle anwesend (" + gamesAlleAnwesend.length + ")")}
        {getGameTabelle(gamesAlleAnwesend)}
        {showAufrufDialog &&
            <ConfirmDialog header="Aufrufen...?" textUnten="Board als aufgerufen markieren?" visible={true}
                           callBackOnNein={() => setShowAufrufDialog(false)} callBackOnJa={() => boardAufrufen()}/>}
    </div>
}
